import * as React from 'react';
import { FunctionComponent } from 'react';
import propz from 'propz';
import { CONFIRMATION_REQUESTS_STATUS_SERVER_TO_CLIENT_MAPPING } from '../../consts/message';
import { getLastResponseUpdatedAtText, getRespondedAtText, getResponseUserText } from 'Src/helpers/message/message';

interface Props {
  messages: any[];
}

export const TournamentConfirmationRequestsSummary: FunctionComponent<Props> = props => {
  const messages = props.messages;

  const rows = messages.map((message, index) => {
    const invitationStatus = propz.get(message, ['invitationStatus'], '');
    const participantSchoolName = propz.get(message, ['participantSchoolData', 'name'], '');
    const invitationStatusMapped = CONFIRMATION_REQUESTS_STATUS_SERVER_TO_CLIENT_MAPPING[invitationStatus];
    const respondedBy = getResponseUserText(message);
    const respondedAt = getRespondedAtText(message);
    const lastChangedAt = getLastResponseUpdatedAtText(message);

    return (
      <tr key={`tournament_confirmation_requests_summary_${index}`}>
        <td>{index + 1}</td>
        <td>{participantSchoolName}</td>
        <td>{invitationStatusMapped}</td>
        <td>{respondedBy || '—'}</td>
        <td>{respondedAt || '—'}</td>
        <td>{lastChangedAt || '—'}</td>
      </tr>
    );
  });

  return (
    <table className={'table table-sm mPre'}>
      <thead>
        <tr key={`tournament_confirmation_requests_summary_heading`}>
          <th />
          <th>Name</th>
          <th>Status</th>
          <th>Responded by</th>
          <th>Responded at</th>
          <th>Last changed</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

TournamentConfirmationRequestsSummary.displayName = 'TournamentConfirmationRequestsSummary';

